import makeStyles from '@material-ui/core/styles/makeStyles';
import {getDate} from '../../../../../../@casino/lib/getDate';
import {parseLogin} from '../../../../../../@casino/lib/parseLogin';

const useStyles = makeStyles(() => ({
    rootTable: {
        width: 'calc(100% - 30px)', borderCollapse: 'inherit', borderSpacing: 0,
        '.trTable': {
            
        }
    },
    trTable: {
        border: 'none',
        cursor: 'pointer',
        '&:hover': {
            background: 'rgba(255,255,255, 0.15)'
        }
    }
}));

const columns = [
    { id: 'id', label: 'ID', sort: true},
    { id: 'login', label: 'Логин', sort: false},
    { id: 'email', label: 'Email', sort: false},
    { id: 'registration', label: 'Дата регистрации', sort: true},
    { id: 'balance', label: 'Баланс', sort: true},
    { id: 'count_deposit', label: 'Кол-во депозитов', sort: true},
    { id: 'sum_deposit', label: 'Сумма пополнений', sort: true},
    { id: 'replenishment_air_balance', label: 'Сумма воздуха', sort: false},
    { id: 'sum_withdrawals', label: 'Сумма выводов', sort: true},
    { id: 'sum_win', label: 'Сумма выигрышей', sort: false},
    { id: 'groups_cashiers', label: 'Закреплен группой', sort: false}
];

const getRows = (data) => {
    return data.map((item) => {
        return {
            id: item.id,
            login: parseLogin(item.login),
            email: item.email,
            registration: getDate(+item.registration),
            balance: new Intl.NumberFormat('ru-RU').format(item.balance ? item.balance.toFixed(2) : item.balance) + ' ' + item.currency,
            sum_deposit: new Intl.NumberFormat('ru-RU').format(item.sum_deposit ? item.sum_deposit.toFixed(2) : item.sum_deposit) + ' ' + item.currency,
            replenishment_air_balance: new Intl.NumberFormat('ru-RU').format(item.replenishment_air_balance ? item.replenishment_air_balance.toFixed(2) : item.replenishment_air_balance) +' ' + item.currency,
            sum_withdrawals: new Intl.NumberFormat('ru-RU').format(item.sum_withdrawals ? item.sum_withdrawals.toFixed(2) : item.sum_withdrawals) + ' ' + item.currency,
            sum_win: new Intl.NumberFormat('ru-RU').format(item.sum_win ? item.sum_win.toFixed(2) : item.sum_withdrawals) +' ' + item.currency,
            groups_cashiers: item.groups_cashiers ? item.groups_cashiers : '',
            count_deposit: new Intl.NumberFormat('ru-RU').format(item.count_deposit ? Number(item.count_deposit)?.toFixed(2) : item.count_deposit)
        }
    })
} 

const GROUPS_CASHIERS_LIST = [{
    label: 'сайтовские',
    value: 'all'
},{
    label: 'любовь',
    value: 'любовь'
}, {
    label: 'латте',
    value: 'латте'
}, {
    label: 'тест',
    value: 'тест'
}, {
    label: 'вишня',
    value: 'вишня'
}, {
    label: 'снежинка',
    value: 'снежинка'
}, {
    label: 'радуга',
    value: 'радуга'
}, {
    label: 'пантера',
    value: 'пантера'
}, {
    label: 'успех',
    value: 'успех'
}, {
    label: 'кавказ',
    value: 'кавказ'
}, {
    label: 'кокос',
    value: 'кокос'
}, {
    label: 'гонка',
    value: 'гонка'
}, {
    label: 'турция',
    value: 'турция'
}, {
    label: 'хинкаль',
    value: 'хинкаль'
}, {
    label: 'крым',
    value: 'крым'
}, {
    label: 'евро',
    value: 'евро'
}, {
    label: 'доллар',
    value: 'доллар'
}, {
    label: 'грузия_тест',
    value: 'грузия_тест'
}, {
    label: 'тесттурция',
    value: 'тесттурция'
}, {
    label: 'азимут_тест',
    value: 'азимут_тест'
}, {
    label: 'ягода_тест',
    value: 'ягода_тест'
}, {
    label: 'ураган_тест',
    value: 'ураган_тест'
}, {
    label: 'альянс_тест',
    value: 'альянс_тест'
}, {
    label: 'викинг_тест',
    value: 'викинг_тест'
}, {
    label: 'фосфор_тест',
    value: 'фосфор_тест'
}, {
    label: 'брюс_тест',
    value: 'брюс_тест'
}, {
    label: 'кит_тест',
    value: 'кит_тест'
}];

const CURRENCY_LIST = [{
    label: 'RUB',
    value: 'RUB'
}, {
    label: 'KZT',
    value: 'KZT'
}, {
    label: 'UZS',
    value: 'UZS'
}, {
    label: 'USD',
    value: 'USD'
}, {
    label: 'EUR',
    value: 'EUR'
}, {
    label: 'GEL',
    value: 'GEL'
}, {
    label: 'TRY',
    value: 'TRY'
}, {
    label: 'INR',
    value: 'INR'
}]


export {
    useStyles,
    columns,
    getRows,
    GROUPS_CASHIERS_LIST,
    CURRENCY_LIST
}